import React from 'react'
import './VerticalRoomsTable.scss'
import { RoomTableProps } from '../RoomsTable'
import RoomsTableItem from './RoomsTableItem'

export default ({ format, rooms, selectedRoom, onSelectRoom }: RoomTableProps) => {
	const items = rooms.map((it) => (
		<RoomsTableItem
			key={it.id}
			format={format}
			room={it}
			onClick={() => {
				onSelectRoom(it.id)
			}}
			isSelected={selectedRoom === it.id}
		/>
	))

	return (
		<div id='room-table' className='room-table--vertical'>
			{items}
		</div>
	)
}
